import styled from 'styled-components';
import { textblocks, buttons } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';
import { theme } from '@Themes/themeOverriderFabric';
import { InfoIcon } from './components';

const { colors, texts, spaces } = getBaseTheme();
const { boxShadowDark } = theme.palette;

export const RadioTitleContainer = styled.div`
    display: flex;
    align-items: center;
    padding: ${spaces.default.s};
`;

export const InfoIconContainer = styled(InfoIcon)({
    marginLeft: `${spaces.default.xxs}`
});

export const WarningContainer = styled.div`
    display: flex;
    align-items: flex-start;
    padding-left: ${spaces.default.s};
    margin-top: ${spaces.default.default};
`;

export const InstructionContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 ${spaces.default.xs};
`;

export const Instruction = styled(textblocks.Text)`
    ${texts.sizes.s};
    padding-bottom: ${spaces.inline.xs};
    width: ${props => props.width}px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: flex-start;
    align-items: center;
    justify-content: space-around;
    margin-top: ${spaces.default.default};
`;

export const IconContainer = styled.div`
    cursor: pointer;
    color: ${colors.control.focus.complementaryForegroundColor};
`;

export const HitContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: ${spaces.default.s};
`;

export const Message = styled(textblocks.Text)`
    color: red;
    display: block;
    text-align: center;
    ${texts.sizes.s};
    margin: ${spaces.inline.xxs};
`;

export const MarkupContainerWrapper = styled.div`
    width: 100%;
`;

export const ButtonDropWrapper = styled.div(
    {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    ({ disabled }) => {
        if (disabled) {
            return {
                pointerEvents: 'none',
                opacity: 0.5
            };
        }
        return;
    }
);

export const StyledButton = styled(buttons.Button)`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding: 0 ${spaces.default.xs};
`;

export const DropDownWrapper = styled.div`
    border-radius: 5px;
    background-color: white;
    padding: 5px 0px;
    display: flex;
    align-items: center;
    flex-direction: column;
    -moz-box-shadow: 0 0 3px ${boxShadowDark};
    -webkit-box-shadow: 0 0 3px ${boxShadowDark};
    box-shadow: 0 0 3px ${boxShadowDark};
`;
export const MarkActionText = styled.button`
    ${texts.sizes.s};
    border: 0;
    background-color: transparent;

    &:hover {
        background: rgb(232, 231, 233);
    }
`;
